import { Button, Select } from 'mailup-web-components'
import PropTypes from 'prop-types'
import { useEffect, useState } from 'react'
import { useIntl } from 'react-intl'
import './SelectFilter.scss'

export const SelectFilter = ({
  options,
  optionGroups,
  lastFilters,
  searchRecipientsCallback
}) => {
  const intl = useIntl()
  const [filter, setFilter] = useState(undefined)
  const [error, setError] = useState(false)
  const [lastFiltersSelected, setLastFiltersSelected] = useState(lastFilters)
  const [lastFiltersList, setLastFiltersList] = useState(lastFilters)

  const handleChange = (selected) => {
    setFilter(selected)
  }

  const selectFilter = (filter) => {
    const listFilter = [
      {
        id: filter.id,
        value: filter.value,
        selected: true
      }
    ]
    // eslint-disable-next-line array-callback-return
    lastFiltersSelected.map((f) => {
      if (f.value !== filter.value) {
        listFilter.push({
          id: f.id,
          value: f.value,
          selected: false
        })
      }
    })

    setLastFiltersSelected(listFilter)
    setFilter(filter.id)
  }

  useEffect(() => {
    if (lastFilters && lastFilters.length > 0) {
      setLastFiltersSelected(lastFilters)

      const filtersList = []
      lastFilters.forEach((filter) => filtersList.push(filter.id))
      setLastFiltersList(filtersList)

      const filters = lastFilters.filter((group) => group.selected)
      if (filters && filters.length > 0) {
        setFilter(filters[0].id)
        initSearchRecipient(filters[0].id)
      }
    }
  }, [lastFilters])

  const searchRecipient = (selectedFilter) => {
    const filters = [selectedFilter]
    lastFiltersList.forEach((filter) => {
      if (selectedFilter !== filter && filters.length < 3) {
        filters.push(filter)
      }
    })

    setLastFiltersList(filters)

    searchRecipientsCallback(
      {
        applyFilters: [selectedFilter]
      },
      {
        lastFilters: [...filters],
        lastTypeSelected: 'filter'
      },
      []
    ).then((res) => {
      if (res.Items.length === 0) {
        setError(true)
      } else {
        setError(false)
      }
    })
  }

  const initSearchRecipient = (selectedFilter) => {
    searchRecipientsCallback(
      {
        applyFilters: [selectedFilter]
      },
      null,
      []
    ).then((res) => {
      if (res.Items.length === 0) {
        setError(true)
      } else {
        setError(false)
      }
    })
  }

  return (
    <div className='c-select-filter'>
      <div className='c-select-filter__header'>
        {intl.formatMessage(
          {
            id: 'Load.PreviewViewer.FilterSelection'
          },
          {
            strong: (content) => <strong key={content}>{content}</strong>
          }
        )}
      </div>
      <div className='c-select-filter__body'>
        <Select
          placeholder={intl.formatMessage({
            id: 'Load.PreviewViewer.FilterSelectionPlaceholder'
          })}
          options={options}
          optionGroups={optionGroups}
          value={filter}
          onChange={handleChange}
          className='c-select-filter__body__select'
        />

        <Button
          onClick={() => searchRecipient(filter)}
          kind='primary'
          disabled={filter === undefined}
        >
          {intl.formatMessage({ id: 'Load.Common.Apply' })}
        </Button>
      </div>
      {error && (
        <div className='c-select-filter__error'>
          {intl.formatMessage({
            id: 'Load.PreviewViewer.ErrorFilterRecipient'
          })}
        </div>
      )}
      {lastFiltersSelected && lastFiltersSelected.length > 0 && (
        <div className='c-select-filter__last-selected'>
          <div className='c-select-filter__last-selected__title'>
            {intl.formatMessage({
              id: 'Load.PreviewViewer.LastSelected'
            })}
          </div>
          {lastFiltersSelected &&
            lastFiltersSelected.map((filter) => (
              <Button
                className='c-select-filter__last-selected__button'
                kind='neutral'
                size='sm'
                disabled={filter.selected}
                key={filter.id}
                onClick={() => selectFilter(filter)}
              >
                {filter.value}
              </Button>
            ))}
        </div>
      )}
    </div>
  )
}

SelectFilter.defaultProps = {
  filters: [],
  lastFilters: []
}

SelectFilter.propTypes = {
  options: PropTypes.arrayOf(PropTypes.object),
  optionGroups: PropTypes.arrayOf(PropTypes.object),
  lastFilters: PropTypes.arrayOf(PropTypes.object),
  searchRecipientsCallback: PropTypes.func
}
